//  libraries
import React from 'react'
import ListTemplate from 'components/common/listTemplate'

function Quote () {
  return <ListTemplate />
}

export default Quote
